import * as React from 'react';
import { PdsIconImage as PdsIconImageElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconImage = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-image',
  elementClass: PdsIconImageElement,
  react: React,
});
